import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 64px;
  padding-top: 24px;
  button {
    float: right;
    height: 40px;
    border-radius: 8px;
    padding: 0 12px;
    margin-left: 8px;
    color: #4c4c4c !important;
    background-color: #f0f0f0 !important;
    border: none;
    font-weight: 700;
    &:hover {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.48;
    }
  }
  div {
    float: right;
    button {
      color: white !important;
      background-color: #2684ff !important;
    }
  }
`

export const CreatedRoleWrapper = styled.div`
  border: 1px solid #b6dbfb;
  background-color: #e7f3fe66;
  padding: 24px;
  border-radius: 8px;
  text-align: center;
  img {
    width: 88px;
    margin-bottom: 8px;
  }
`

export const Title = styled.div`
  color: #213f68;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
`

export const Question = styled.div`
  color: #363636;
`
